import Vue from "vue";
import VueRouter from "vue-router";
import { abilitiesPlugin } from "@casl/vue";
import processesAbilities from "./js/ability/processesAbilities";
import { Can } from "@casl/vue";
// Needs to be this path for Scrollspy to work in IE11
import Scrollspy from "vue2-scrollspy/dist/index";
import Store from "./js/vuex-store/";
import VueScrollTo from "vue-scrollto";
import Affix from "vue-affix";
import clickOutside from "./js/utils/vue-mixins/click-outside.js";
import ProcessDataProvider from "./components/INQ/process-data-provider/ProcessDataProvider.vue";
import ProcessItem from "./components/INQ/process-item/ProcessItem.vue";
import ProcessStep from "./components/INQ/process-step/ProcessStep.vue";
import ProcessStepSummary from "./components/INQ/process-step-summary/ProcessStepSummary.vue";
import ProcessStepsDataProvider from "./components/INQ/process-steps-data-provider/ProcessStepsDataProvider.vue";
import ProcessSteps from "./components/INQ/process-steps/ProcessSteps.vue";
import ProcessPage from "./components/INQ/process-page/ProcessPage.vue";
import ProcessesPage from "./components/INQ/processes-page/ProcessesPage.vue";
import Resources from "./components/INQ/resources/Resources.vue";
import ResourceItem from "./components/INQ/resource-item/ResourceItem.vue";
import ResourcesDataProvider from "./components/INQ/resources-data-provider/ResourcesDataProvider";
import ResourceLinks from "./components/INQ/resource-links/ResourceLinks";
import ResourceLink from "./components/INQ/resource-link/ResourceLink";
import ResourceLinksDataProvider from "./components/INQ/resource-links-data-provider/ResourceLinksDataProvider";
import ProcessesDataProvider from "./components/INQ/processes-data-provider/ProcessesDataProvider";
import Processes from "./components/INQ/processes/Processes.vue";
import ProcessTeaser from "./components/INQ/process-teaser/ProcessTeaser.vue";
import ToggleStatus from "./components/INQ/toggle-status/ToggleStatus.vue";
import VueInput from "./components/vue-components/vue-input/VueInput.vue";
import ChangeLog from "./components/INQ/change-log/ChangeLog.vue";
import ChangeLogDataProvider from "./components/INQ/change-log-data-provider/ChangeLogDataProvider.vue";
import VueTabs from "./components/vue-components/vue-tabs/VueTabs.vue";
import VueIcon from "./components/vue-components/vue-icon/VueIcon.vue";
import NotifyPill from "./components/vue-components/notify-pill/NotifyPill.vue";
import Modal from "./components/vue-components/modal/Modal.vue";
import VueBreadcrumbs from "./components/vue-components/vue-breadcrumbs/VueBreadcrumbs.vue";
import DropdownVariations from "./components/vue-components/dropdown-variations/DropdownVariations.vue";

Vue.use(VueRouter);
Vue.use(abilitiesPlugin, processesAbilities(document.querySelector("#app")));
Vue.component("can", Can);
Vue.use(VueScrollTo);
Vue.use(Scrollspy);
Vue.use(Affix);
Vue.use(clickOutside);

const routes = [
  { path: "/", component: ProcessesPage },
  { path: "/create-process/:category", component: ProcessPage },
  { path: "/process/:id/", name: "process", component: ProcessPage },
];
const Router = new VueRouter({
  routes: routes,
  /* eslint no-unused-vars: "off" */
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

if (document.querySelector("#app")) {
  new Vue({
    el: "#app",
    store: Store,
    router: Router,
    components: {
      ProcessesDataProvider,
      ProcessDataProvider,
      ProcessStepsDataProvider,
      Processes,
      ProcessTeaser,
      ProcessItem,
      ProcessStep,
      ProcessSteps,
      ResourceItem,
      Resources,
      ToggleStatus,
      VueInput,
      ResourcesDataProvider,
      ResourceLinksDataProvider,
      ResourceLinks,
      ResourceLink,
      ChangeLog,
      ChangeLogDataProvider,
      VueTabs,
      VueIcon,
      ProcessStepSummary,
      NotifyPill,
      Modal,
      VueBreadcrumbs,
      DropdownVariations
    },
  });
}
